import { VFC, useMemo } from 'react';
import { MIN_CURRENT_VALUES, MinCurrent, UNIT_TRANSLATED, Unit } from '@enmon/commons';
import { useIntl } from 'react-intl';
import { Select } from '../../Select';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';

interface MinCurrentSelectProps {
  value?: MinCurrent;
  onChange?: (value: MinCurrent) => void;
}

export const MinCurrentSelect: VFC<MinCurrentSelectProps> = ({ ...restProps }: MinCurrentSelectProps) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const minCurrentOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: MIN_CURRENT_VALUES,
        suggestedValue: meterModelSuggestions?.iMin?.value,
        suggestedSelection: meterModelSuggestions?.iMin?.selection,
      }),
    [intl, meterModelSuggestions],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={minCurrentOptions}
      placeholder={MinCurrent['MinCurrent-0.05']}
      suffix={UNIT_TRANSLATED[Unit.A]}
      {...restProps}
    />
  );
};
